export enum OutletType {
    RUKO = "RUKO",
    SHACK = "SHACK",
    ALL = "ALL",
    CUSTOM = "CUSTOM",
}
